import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FormButton } from 'eone-ui/forms/form-Button';
import { useCallback } from 'react';
import { SCFormLabel } from '../form';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import { handleFieldUp } from './helper';
import './styles.css';

interface SCFormFieldButtonProps extends SCFormFieldProps {
  AutoFocus?: boolean;
  Icon?: IconProp;
  Label?: string;
  OnClick?: () => void;
  Type?: 'primary' | 'danger';
}

const SCFormFieldButton = ({
  label,
  name,
  required,
  disabled,
  rules,
  Type,
  ...rest
}: SCFormFieldButtonProps) => {
  const getClass = useCallback(() => {
    switch (Type) {
      case 'primary':
        return 'sc-eone-ui-form-field-button-primary';
      case 'danger':
        return 'sc-eone-ui-form-field-button-danger';
      default:
        return '';
    }
  }, [Type]);

  return (
    <SCFormField label={label} name={name} disabled={disabled} required={required} rules={rules}>
      {({ field }) => {
        const { OnChange, ...restField } = handleFieldUp(field, { disabledRef: true });

        return (
          <>
            {label && <SCFormLabel label={label} required={required} />}
            {/* Crying, it should be onToggle instead of onChange */}
            <FormButton
              {...restField}
              OnToggle={OnChange}
              ReadOnly={restField.Disabled}
              {...rest}
              Class={getClass()}
            />
          </>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldButton };
export type { SCFormFieldButtonProps };
